var map = {
	"./acuerdoCapte01.jpg": "563d",
	"./acuerdoCapte02.jpg": "45a6",
	"./acuerdoCapte03.jpg": "13d6",
	"./acuerdoCapte04.jpg": "6dec",
	"./acuerdoCapte05.jpg": "528f",
	"./acuerdoCapte06.jpg": "3886",
	"./aficheA4-CursoFormacion.jpg": "026c",
	"./afiliate.jpg": "67ce",
	"./aniversario7.jpg": "8518",
	"./aniversario_7.jpg": "1565",
	"./asamblea26082025.fff075ac.jpg": "cb80",
	"./asamblea26082025.jpg": "0a37",
	"./ayudaSolidaria.jpg": "ca2c",
	"./campanaSolidaria-Fondo.jpg": "abee",
	"./campanaSolidariaFondo.jpg": "bfb6",
	"./capac_olavarria.jpg": "f265",
	"./capac_pais.jpg": "ca44",
	"./caper.jpg": "f682",
	"./censo_web.jpg": "20a9",
	"./clinica_cordoba.jpg": "4b4b",
	"./consejos.jpg": "306c",
	"./convenioSindical.jpg": "5109",
	"./convenioSindical1.jpg": "d4fe",
	"./convenioSindical2.jpg": "ceae",
	"./convenioSindical3.jpg": "5f13",
	"./convenio_acmma.jpg": "ed30",
	"./convenio_inamu2.jpg": "a9de",
	"./convoca_asamblea.jpg": "ec40",
	"./convocatoriaJunio2022.jpg": "9894",
	"./coronavirus.jpg": "e091",
	"./covid.jpg": "d255",
	"./cuota.jpg": "3e3d",
	"./cuotaSocial.jpg": "f34f",
	"./cupo_femenino.jpg": "3da5",
	"./diaTecnicoEsc.jpg": "eaaa",
	"./elecciones18022026.jpg": "e8b8",
	"./eleccionesGenerales2022.jpg": "e3b5",
	"./escala-valores.jpg": "a417",
	"./expo2018.jpg": "e698",
	"./flyer_asamblea2020_suspendida.jpg": "e926",
	"./flyer_reclamo2020.jpg": "8caf",
	"./fondoArtes.jpg": "4413",
	"./fondoArtes2.jpg": "81dd",
	"./formacionLaboral.jpg": "04d5",
	"./foto_seguridad.jpg": "8d96",
	"./imagCovid.jpg": "239c",
	"./imagen-web-logo.jpg": "c2bd",
	"./imagen1mayo_web.jpg": "1c31",
	"./imagenBecas.jpg": "1713",
	"./imagen_10anios.jpg": "ca08",
	"./imagen_becas.jpg": "0d13",
	"./imagen_covid.jpg": "d763",
	"./imagen_web-logo.jpg": "7232",
	"./imagen_web_cursos.jpg": "d47c",
	"./listaUnidad.jpg": "f6a2",
	"./ma3_marzo19.jpg": "d4bc",
	"./mail_contacto.jpg": "2518",
	"./marcha-sate.jpg": "bba5",
	"./mencion_honor.jpg": "ecfb",
	"./midas_titulo.jpg": "2a83",
	"./movilizacion.jpg": "b122",
	"./noa_opera.jpg": "39e8",
	"./noti_manual.jpg": "f782",
	"./pantalla2.jpg": "173d",
	"./parachenian.jpg": "dab7",
	"./prevencionLaRioja.jpg": "36d3",
	"./protoCovid.jpg": "2787",
	"./reunionSanJuan.jpg": "72d2",
	"./salario.jpg": "862a",
	"./segundaCampaSolidaria.jpg": "e4ce",
	"./semin_wireless.jpg": "0e78",
	"./sonido2.jpg": "6882",
	"./spott_corrientes.jpg": "00bc",
	"./spott_salta.jpg": "94a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96c0";